export const myCompare = (a, b) => a.label && a.label.toString().toLowerCase() > b.label && b.label.toString().toLowerCase() ? 1 : -1;


